<template>
  <div id="app">
    <router-view/>
    <loading-screen :is-loading="isLoading"></loading-screen>
  </div>
</template>
<script>
import LoadingScreen from './components/LoadingScreen.vue';
export default {
  name: 'App',
  components: {LoadingScreen},
  computed: {
    isLoading() {
      return this.$store.state.callingAPI;
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
